import { useQuery } from "@tanstack/react-query";
import axios from "axios";

// material-ui
import { useTheme } from "@mui/material/styles";
import { Box, Button, GridLegacy as Grid, useMediaQuery } from "@mui/material";

// project imports
import AnimateButton from "ui-component/extended/AnimateButton";

import TenDuke from "assets/images/icons/10duke.png";

const LogInWithTenDukeButton = ({}) => {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down("md"));

  const getConfigQuery = useQuery({
    queryKey: ["config"],
    queryFn: () => {
      return axios.get("/api/config");
    },
  });

  const isPending = getConfigQuery.isPending;
  const isError = getConfigQuery.isError;

  if (isPending) {
    return <span>Loading...</span>;
  }

  if (isError) {
    return <span>{getConfigQuery.error.message}</span>;
  }

  const { DUKE_BASE_URL, DUKE_CLIENT_ID, DUKE_REDIRECT_URI, DUKE_SCOPE } = getConfigQuery.data.data;

  const dukeAuthURL = `${DUKE_BASE_URL}/user/oauth20/authz?response_type=code&client_id=${DUKE_CLIENT_ID}&redirect_uri=${DUKE_REDIRECT_URI}&scope=${DUKE_SCOPE}`;

  return (
    <a href={dukeAuthURL}>
      <Grid container direction="column" justifyContent="center" spacing={2}>
        <Grid item xs={12}>
          <AnimateButton>
            <Button
              disableElevation
              fullWidth
              onClick={() => {}}
              size="large"
              variant="outlined"
              sx={{
                color: "grey.700",
                backgroundColor: theme.palette.grey[50],
                borderColor: theme.palette.grey[100],
              }}
            >
              <Box sx={{ mr: { xs: 1, sm: 2, width: 50 } }}>
                <img src={TenDuke} alt="google" width={50} height={50} style={{ marginRight: matchDownSM ? 8 : 16 }} />
              </Box>
              Sign in with 10Duke
            </Button>
          </AnimateButton>
        </Grid>
      </Grid>
    </a>
  );
};

export default LogInWithTenDukeButton;
